export default __webpack_public_path__ + "static/media/bell.e83a34f3.png";